// ADR 5.9.26u §3 — the shell, now that there is one.
//
// 5.9.26i put a placeholder here to prove the build, the router, react-query
// and the catalogue wire together. That job is done, so this file is what it
// always meant to be: the name the route table hangs the layout off, and one
// indirection so `router.tsx` never has to know which layout it is.
//
// ADR 15.9.26ah §7 — `ScrollRestoration` is react-router's own: back/forward
// restore position and a new location lands at the top, which every native
// stack has for free. No `getKey` — the default keys on location. It calls
// `useDataRouterContext`, so it throws outside a data router: production
// mounts `Shell` under `createBrowserRouter`, and every suite that mounts it
// builds a `createMemoryRouter`.
//
// ADR 23.9.26u §7 / 28.9.26d §1 — `UpdateToast` rides in `SnackbarHost`'s
// pinned slot, and since ADR 29.9.26al §4 the host is mounted inside
// `AdaptiveShell` (appended after its frame, so no slot index moves), where it
// can read the window class.
//
// ADR 24.9.26l §2 — `RouteAnnouncer` beside `AdaptiveShell`, outside it so the
// shell's slot indices are untouched: the title, the focus move and the polite
// announcement on every route change.

import { ScrollRestoration } from 'react-router-dom'

import { RouteAnnouncer } from './RouteAnnouncer'
import { AdaptiveShell } from '../layout/AdaptiveShell'
import { useOfflineQueue } from '../offline/queue/useOfflineQueue'

export function Shell() {
  // ADR 23.9.26w §7 — the queue's triggers and owner tag, mounted once, under
  // the session provider and the query client that both need.
  useOfflineQueue()
  return (
    <>
      <AdaptiveShell />
      <ScrollRestoration />
      <RouteAnnouncer />
    </>
  )
}
